// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgr_a","AdSlotBranding__desktop":"bgr_b","AdSlotBranding__mobile":"bgr_c"};